import { useStore } from "zustand";

import { createEnvStore, TEnvStore } from "./store";

export const EnvStoreContext = createEnvStore();

const state = EnvStoreContext.getState();

if (state.version === null) {
  await state.fetchEnvs();
}
// Reactive selector

export const useEnvs = <T = TEnvStore>(
  selector: (state: TEnvStore) => T = (s) => s as unknown as T,
) => {
  return useStore(EnvStoreContext, selector);
};

// Non-reactive selector
export const getEnvs = <T>(selector: (state: TEnvStore) => T) => {
  const state = EnvStoreContext.getState();
  return selector(state);
};
